module.exports = __webpack_public_path__ + "img/file.d9f65012.svg";